import { render, staticRenderFns } from "./CompanyDetailsView.vue?vue&type=template&id=9d5bc276&scoped=true"
import script from "./CompanyDetailsView.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsView.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetailsView.vue?vue&type=style&index=0&id=9d5bc276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5bc276",
  null
  
)

export default component.exports